// extracted by mini-css-extract-plugin
export default {"section":"page-500_section__zytLm","title":"page-500_title__JCWNz","titleContainer":"page-500_titleContainer__ykzNk"};